import { SlotNames } from "./slots/mapping.js";
import { createSlot } from "./slots/create.js";
import * as element from "./slots/element.js";
const createSlotFactory = (type, config = {}) => (props) => createSlot({ ...props, type, ...config });
const actions = {
  default: createSlotFactory(SlotNames.actions.default)
};
const assets = {
  image: createSlotFactory(SlotNames.assets.image),
  images: createSlotFactory(SlotNames.assets.images),
  video: createSlotFactory(SlotNames.assets.video)
};
const contact = {
  additional: createSlotFactory(SlotNames.contact.additional),
  address: createSlotFactory(SlotNames.contact.address),
  email: createSlotFactory(SlotNames.contact.email),
  location: createSlotFactory(SlotNames.contact.location),
  phone: createSlotFactory(SlotNames.contact.phone)
};
const content = {
  default: createSlotFactory(SlotNames.content.default)
};
const date = {
  default: createSlotFactory(SlotNames.date.default)
};
const eyebrow = {
  default: createSlotFactory(SlotNames.eyebrows.default)
};
const headline = {
  default: createSlotFactory(SlotNames.headline.default)
};
const person = {
  association: createSlotFactory(SlotNames.person.association),
  name: createSlotFactory(SlotNames.person.name),
  jobTitle: createSlotFactory(SlotNames.person.jobTitle),
  pronouns: createSlotFactory(SlotNames.person.pronouns)
};
const social = {
  linkedin: createSlotFactory(SlotNames.social.linkedin)
};
const text = {
  caption: createSlotFactory(SlotNames.text.caption),
  default: createSlotFactory(SlotNames.text.default),
  stat: createSlotFactory(SlotNames.text.stat),
  stats: createSlotFactory(SlotNames.text.stats),
  subText: createSlotFactory(SlotNames.text.sub)
};
const deprecated = {
  ADDITIONAL: createSlotFactory(SlotNames.ADDITIONAL),
  body: createSlotFactory(SlotNames.deprecated.body),
  wrappingText: createSlotFactory(SlotNames.deprecated.wrappingText),
  plainText: createSlotFactory(SlotNames.deprecated.plainText),
  stat: createSlotFactory(SlotNames.deprecated.stat),
  backgroundImage: createSlotFactory(SlotNames.deprecated.backgroundImage),
  contactHeadline: createSlotFactory(SlotNames.deprecated.contactHeadline),
  contactAddress: createSlotFactory(SlotNames.deprecated.contactAddress),
  callToAction: createSlotFactory(SlotNames.deprecated.callToAction)
};
const Slots = {
  actions,
  assets,
  contact,
  content,
  date,
  deprecated,
  element,
  eyebrow,
  person,
  name: SlotNames,
  headline,
  social,
  text,
  ...element
};
export {
  Slots
};
//# sourceMappingURL=slots.js.map
